import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import PageWrapper from "./PageWrapper";
import { useQuizContext } from "./QuizContext";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import "./SignupCommon.css";
const SignupPage13: React.FC = () => {
  const [idealWeight, setIdealWeight] = useState<string>("");
  const { setAnswer, answers } = useQuizContext();
  const [error, setError] = useState<string>("");

  const handleNext = () => {
    if (idealWeight) {
      localStorage.setItem(
        "idealWeight",
        JSON.stringify({ key: "idealWeight", value: idealWeight, id: 18026063 })
      );
      setAnswer("idealWeight", idealWeight, "18026063");
    }
    localStorage.setItem("step-8-completed", "true");
  };
  const navigate = useNavigate();

  useEffect(() => {
    const step7Completed = localStorage.getItem("step-7-completed");
    if (step7Completed) {
      navigate("/getting-started/step-8",{ replace: true });
    } else {
      navigate("/getting-started/step-7",{ replace: true });
    }
  }, []);

  useEffect(() => {
    const savedIdealWeight = localStorage.getItem("idealWeight");

    if (savedIdealWeight) {
      const parsedIdealWeight = JSON.parse(savedIdealWeight);
      setIdealWeight(parsedIdealWeight.value);
    }
  }, []);

  const styles = {
    label: {
      marginBottom: "10px",
      fontWeight: "bold",
    },
    inputContainer: {
      marginBottom: "20px",
    },
    button: {
      backgroundColor: "#007bff",
      color: "white",
      padding: "10px 20px",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      fontSize: "16px",
      marginTop: "20px",
    },
    disabledButton: {
      backgroundColor: "#ccc",
      cursor: "not-allowed",
    },
    errorText: {
      color: "red",
      fontSize: "12px",
      marginTop: "5px",
    },
  };
  const handleIdealWeightChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newWeight = e.target.value;
    setIdealWeight(newWeight);
    if (parseFloat(newWeight) <= 0) {
      setError("Ideal Weight should be greater than 0.");
      return;
    }
    setError("");
  };
  const isVariant = localStorage.getItem("isVariant") === "true";
  const step = 8;
  return (
    <PageWrapper>
      <div className="signup-page-container container">
        <ProgressBar progress={isVariant ? 100 : 80} step={step} />
        <div className="signup-content">
          <p className="signup-question signup-question-mobile">
            What is your ideal weight?
          </p>
          <div style={styles.inputContainer}>
            <input
              id="weight-input"
              type="number"
              value={idealWeight}
              onChange={handleIdealWeightChange}
              placeholder="LBS"
              className="weight-input"
            />
            {error && <p style={styles.errorText}>{error}</p>}
          </div>
          <Link to="/getting-started/step-9">
            <button
              onClick={handleNext}
              disabled={!idealWeight || !!error}
              className="next-btn sticky-btn"
            >
              Continue →
            </button>
          </Link>
        </div>
      </div>
    </PageWrapper>
  );
};

export default SignupPage13;
